import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAccount } from '../contexts/AccountContext';

const ProtectedRoute = () => {
  const { account: user } = useAccount();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
